import { getIncentivesSum } from 'site-modules/shared/utils/inventory/price-analysis';
import { getCashByTermsRange } from 'site-modules/shared/utils/car-buying/get-cash-by-terms-range';

export const getTotalRebates = ({ incentives, showLeasePayments }) =>
  showLeasePayments
    ? incentives.reduce((sum, incentive) => sum + getCashByTermsRange(incentive), 0)
    : getIncentivesSum(incentives);
